<template>
  <div class="test-data-container">
    <!-- 左侧内容区域，占比65% -->
    <div class="left-content">
      <!-- 第一块：选择区域 -->
      <div class="dashboard-card">
        <div class="filter-section">
          <div class="filter-item">
            <label>选择企业</label>
            <a-select v-model:value="selectedEnterprise" style="width: 100%">
              <a-select-option v-for="enterprise in enterpriseList" :key="enterprise.id" :value="enterprise.id">
                {{ enterprise.name }}
              </a-select-option>
            </a-select>
          </div>
          <div class="filter-item">
            <label>选择车辆</label>
            <a-select v-model:value="selectedVehicle" style="width: 100%">
              <a-select-option value="1">车辆1</a-select-option>
              <a-select-option value="2">车辆2</a-select-option>
              <a-select-option value="3">车辆3</a-select-option>
            </a-select>
          </div>
          <div class="filter-item">
            <label>统计时间</label>
            <a-date-picker v-model:value="dateRange" range style="width: 100%" />
          </div>

        </div>
      </div>

      <!-- 第二块：测试里程统计柱状图 -->
      <div class="dashboard-card">
        <div class="card-header">
          <h3>测试里程统计</h3>
        </div>
        <div ref="mileageChart" class="chart-container"></div>
      </div>

      <!-- 第三块：测试平均驾驶速度统计柱状图 -->
      <div class="dashboard-card">
        <div class="card-header">
          <h3>测试平均驾驶速度统计</h3>
        </div>
        <div ref="speedChart" class="chart-container"></div>
      </div>
      <!-- 第三块：急刹事件统计 -->
      <div class="dashboard-card">
        <div class="card-header">
          <h3>急刹事件统计</h3>
        </div>
        <div ref="brakeChart" class="chart-container"></div>
      </div>
    </div>

    <!-- 右侧内容区域，占比35% -->
    <div class="right-content">
      <!-- 车辆基本信息 -->
      <div class="dashboard-card">
        <div class="card-header">
          <h3>车辆基本信息</h3>
        </div>
        <div class="vehicle-info">
          <div class="info-item">
            <span class="info-label">车辆型号：</span>
            <span class="info-value">{{ vehicleInfo.model }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">车辆编号：</span>
            <span class="info-value">{{ vehicleInfo.id }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">所属企业：</span>
            <span class="info-value">{{ vehicleInfo.enterprise }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">测试状态：</span>
            <span class="info-value status-{{ vehicleInfo.status }}">{{ vehicleInfo.statusText }}</span>
          </div>
        </div>
      </div>

      <!-- 测试数据概览 -->
      <div class="dashboard-card">
        <div class="card-header">
          <h3>测试数据概览</h3>
        </div>
        <div class="overview-stats">
          <div class="stat-item">
            <div class="stat-value">{{ overviewStats.totalMileage }}</div>
            <div class="stat-label">总测试里程</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">{{ overviewStats.testDays }}</div>
            <div class="stat-label">测试天数</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">{{ overviewStats.avgSpeed }}</div>
            <div class="stat-label">平均速度</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">{{ overviewStats.maxSpeed }}</div>
            <div class="stat-label">最高速度</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">{{ overviewStats.maxSpeed }}</div>
            <div class="stat-label">脱离次数</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">{{ overviewStats.maxSpeed }}</div>
            <div class="stat-label">急刹次数</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">{{ overviewStats.maxSpeed }}</div>
            <div class="stat-label">脱离率</div>
          </div>
          <div class="stat-item">
            <div class="stat-value">{{ overviewStats.maxSpeed }}</div>
            <div class="stat-label">急刹率</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch } from 'vue'
import * as echarts from 'echarts'
import { DatePicker, Select, Radio } from 'ant-design-vue'
import { getCompanyList } from '@/api/enterprise/index'

// 筛选条件
const selectedEnterprise = ref('')
const selectedVehicle = ref('1')
const dateRange = ref(null)

// 企业列表
const enterpriseList = ref([])

// 车辆信息
const vehicleInfo = ref({
  model: '自动驾驶测试车',
  id: 'TEST-001',
  enterprise: '企业A',
  status: 'active',
  statusText: '测试中'
})

// 测试数据概览
const overviewStats = ref({
  totalMileage: '12,500 km',
  avgSpeed: '45 km/h',
  maxSpeed: '80 km/h',
  testDays: '30 天'
})

// 图表引用
const mileageChart = ref(null)
let mileageChartInstance = null
const speedChart = ref(null)
let speedChartInstance = null
const brakeChart = ref(null)
let brakeChartInstance = null

// 测试里程数据
const mileageData = ref({
  month: Array.from({ length: 36 }, (_, i) => ({
    name: `${Math.floor(i / 12) + 2023}年${(i % 12) + 1}月`,
    auto: 500 + Math.floor(Math.random() * 1500), // 每条数据都有值
    manual: 200 + Math.floor(Math.random() * 800) // 每条数据都有值
  })),
  day: Array.from({ length: 31 }, (_, i) => ({
    name: `${i + 1}日`,
    auto: 30 + Math.floor(Math.random() * 70), // 每条数据都有值
    manual: 10 + Math.floor(Math.random() * 40) // 每条数据都有值
  }))
})

// 平均速度数据
const speedData = ref({
  month: Array.from({ length: 36 }, (_, i) => ({
    name: `${Math.floor(i / 12) + 2023}年${(i % 12) + 1}月`,
    value: 40 + Math.floor(Math.random() * 20)
  })),
  day: Array.from({ length: 31 }, (_, i) => ({
    name: `${i + 1}日`,
    value: 35 + Math.floor(Math.random() * 25)
  }))
})

// 急刹事件数据
const brakeData = ref({
  month: Array.from({ length: 36 }, (_, i) => ({
    name: `${Math.floor(i / 12) + 2023}年${(i % 12) + 1}月`,
    '5-10': Math.floor(Math.random() * 10), // 急刹速度大于5km/h小于10km/h
    '10-20': Math.floor(Math.random() * 5), // 急刹速度大于10km/h小于20km/h
    '20+': Math.floor(Math.random() * 3) // 急刹速度大于20km/h
  }))
})

// 初始化测试里程统计柱状图
const initMileageChart = () => {
  if (!mileageChart.value) return

  // 确保销毁旧的图表实例
  if (mileageChartInstance) {
    mileageChartInstance.dispose()
    mileageChartInstance = null
  }

  // 初始化图表实例
  mileageChartInstance = echarts.init(mileageChart.value)

  // 获取按月统计的数据
  const chartData = mileageData.value.month
  const xAxisData = chartData.map(item => item.name)

  // 图表配置
  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      },
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      textStyle: {
        color: '#fff'
      },
      formatter: function(params) {
        let result = params[0].name + '<br/>';
        params.forEach(item => {
          result += item.marker + item.seriesName + ': ' + item.value + ' km<br/>';
        });
        return result;
      }
    },
    legend: {
      data: ['自动驾驶', '人工驾驶'],
      textStyle: {
        color: '#666666'
      },
      right: '10%',
      top: '5%'
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '10%',
      top: '15%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: xAxisData,
      axisLabel: {
        color: '#666666',
        fontSize: 12
      },
      axisLine: {
        lineStyle: {
          color: 'rgba(0, 0, 0, 0.2)'
        }
      },
      axisTick: {
        show: false
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: '#666666',
        fontSize: 12,
        formatter: '{value} km'
      },
      axisLine: {
        lineStyle: {
          color: 'rgba(0, 0, 0, 0.2)'
        }
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(0, 0, 0, 0.1)'
        }
      }
    },
    series: [
      {
        name: '自动驾驶',
        type: 'bar',
        stack: 'total',
        barWidth: '60%',
        data: chartData.map(item => item.auto),
        itemStyle: {
          color: '#28a745',
          borderRadius: [0, 0, 0, 0]
        }
      },
      {
        name: '人工驾驶',
        type: 'bar',
        stack: 'total',
        barWidth: '60%',
        data: chartData.map(item => item.manual),
        itemStyle: {
          color: '#fd7e14',
          borderRadius: [4, 4, 0, 0]
        }
      }
    ]
  }

  // 设置图表配置
  mileageChartInstance.setOption(option)
}

// 初始化测试平均驾驶速度统计柱状图，只显示最高点
const initSpeedChart = () => {
  if (!speedChart.value) return

  // 确保销毁旧的图表实例
  if (speedChartInstance) {
    speedChartInstance.dispose()
    speedChartInstance = null
  }

  // 初始化图表实例
  speedChartInstance = echarts.init(speedChart.value)

  // 获取按月统计的数据
  const chartData = speedData.value.month
  const xAxisData = chartData.map(item => item.name)
  const seriesData = chartData.map(item => item.value)



  // 图表配置
  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      },
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      textStyle: {
        color: '#fff'
      },
      formatter: '{b}: {c} km/h'
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '10%',
      top: '10%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: xAxisData,
      axisLabel: {
        color: '#666666',
        fontSize: 12
      },
      axisLine: {
        lineStyle: {
          color: 'rgba(0, 0, 0, 0.2)'
        }
      },
      axisTick: {
        show: false
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: '#666666',
        fontSize: 12,
        formatter: '{value} km/h'
      },
      axisLine: {
        lineStyle: {
          color: 'rgba(0, 0, 0, 0.2)'
        }
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(0, 0, 0, 0.1)'
        }
      }
    },
    series: [
      {
        name: '平均速度',
        type: 'scatter',
        data: seriesData.map((value, index) => ({
          value: [index, value],
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#28a745' },
              { offset: 1, color: '#20c997' }
            ])
          }
        })),
        symbol: 'rect',
        symbolSize: [14, 6],
        label: {
          show: false
        }
      }
    ]
  }

  // 设置图表配置
  speedChartInstance.setOption(option)
}

// 初始化急刹事件统计柱状图
const initBrakeChart = () => {
  if (!brakeChart.value) return

  // 确保销毁旧的图表实例
  if (brakeChartInstance) {
    brakeChartInstance.dispose()
    brakeChartInstance = null
  }

  // 初始化图表实例
  brakeChartInstance = echarts.init(brakeChart.value)

  // 获取按月统计的数据
  const chartData = brakeData.value.month
  const xAxisData = chartData.map(item => item.name)

  // 图表配置
  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      },
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      textStyle: {
        color: '#fff'
      },
      formatter: function(params) {
        let result = params[0].name + '<br/>';
        params.forEach(item => {
          result += item.marker + item.seriesName + ': ' + item.value + ' 次<br/>';
        });
        return result;
      }
    },
    legend: {
      data: ['5-10 km/h', '10-20 km/h', '20+ km/h'],
      textStyle: {
        color: '#666666'
      },
      right: '10%',
      top: '5%'
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '10%',
      top: '15%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: xAxisData,
      axisLabel: {
        color: '#666666',
        fontSize: 12
      },
      axisLine: {
        lineStyle: {
          color: 'rgba(0, 0, 0, 0.2)'
        }
      },
      axisTick: {
        show: false
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: '#666666',
        fontSize: 12,
        formatter: '{value} 次'
      },
      axisLine: {
        lineStyle: {
          color: 'rgba(0, 0, 0, 0.2)'
        }
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(0, 0, 0, 0.1)'
        }
      }
    },
    series: [
      {
        name: '5-10 km/h',
        type: 'bar',
        stack: 'total',
        barWidth: '60%',
        data: chartData.map(item => item['5-10']),
        itemStyle: {
          color: '#28a745',
          borderRadius: [0, 0, 0, 0]
        }
      },
      {
        name: '10-20 km/h',
        type: 'bar',
        stack: 'total',
        barWidth: '60%',
        data: chartData.map(item => item['10-20']),
        itemStyle: {
          color: '#ffc107',
          borderRadius: [0, 0, 0, 0]
        }
      },
      {
        name: '20+ km/h',
        type: 'bar',
        stack: 'total',
        barWidth: '60%',
        data: chartData.map(item => item['20+']),
        itemStyle: {
          color: '#dc3545',
          borderRadius: [4, 4, 0, 0]
        }
      }
    ]
  }

  // 设置图表配置
  brakeChartInstance.setOption(option)
}

// 窗口大小变化时重新调整图表大小
const handleResize = () => {
  if (mileageChartInstance) {
    mileageChartInstance.resize()
  }
  if (speedChartInstance) {
    speedChartInstance.resize()
  }
  if (brakeChartInstance) {
    brakeChartInstance.resize()
  }
}

// 统计方式固定为按月，不需要监听变化

const updateCharts = () => {
  initMileageChart()
  initSpeedChart()
  initBrakeChart()
}

// 获取企业列表
const fetchEnterpriseList = async () => {
  try {
    const response = await getCompanyList()
    if (response.code === 200) {
      enterpriseList.value = response.data
      // 如果有企业列表，默认选择第一个
      if (enterpriseList.value.length > 0) {
        selectedEnterprise.value = enterpriseList.value[0].id
      }
    }
  } catch (error) {
    console.error('获取企业列表失败:', error)
  }
}

// 组件挂载后初始化图表
onMounted(() => {
  // 获取企业列表
  fetchEnterpriseList()
  
  // 延迟初始化图表，确保DOM已渲染
  setTimeout(() => {
    initMileageChart()
    initSpeedChart()
    initBrakeChart()
  }, 100)

  // 添加窗口大小变化监听
  window.addEventListener('resize', handleResize)
})

onBeforeUnmount(() => {
  // 销毁图表实例
  if (mileageChartInstance) {
    mileageChartInstance.dispose()
    mileageChartInstance = null
  }
  if (speedChartInstance) {
    speedChartInstance.dispose()
    speedChartInstance = null
  }
  if (brakeChartInstance) {
    brakeChartInstance.dispose()
    brakeChartInstance = null
  }

  // 移除窗口大小变化监听
  window.removeEventListener('resize', handleResize)
})
</script>

<style scoped lang="less">
.test-data-container {
  display: flex;
  width: 100%;
  height: calc(100vh - 70px);
  overflow: hidden;
  background: #ffffff;
  padding: 20px;
  gap: 20px;
}

// 左侧内容区域，占比65%
.left-content {
  flex: 6.5;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
}

// 右侧内容区域，占比35%
.right-content {
  flex: 3.5;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
}

// 统一卡片组件样式
.dashboard-card {
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid rgba(92, 172, 238, 0.3);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 16px;
  width: 100%;
  position: relative;
  display: block;
  overflow: visible;
  width: 100%;
  box-sizing: border-box;
}

// 卡片标题
.card-header {
  margin-bottom: 16px;
  padding-bottom: 8px;
  position: relative;
}

.card-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  display: inline-block;
}

/* 主线条 - 粗线条 */
.card-header::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 5px;
  width: 30%;
  height: 3px;
  background-color: #5CACEE;
  border-radius: 2px;
  z-index: 2;
}

/* 细线条 */
.card-header::before {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background-color: rgba(92, 172, 238, 0.5);
  border-radius: 1px;
  z-index: 1;
}

// 筛选区域样式
.filter-section {
  display: flex;
  gap: 16px;
}

.filter-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-item label {
  font-size: 14px;
  color: #666666;
  opacity: 1;
}

// 图表容器
.chart-container {
  width: 100%;
  height: 300px;
  position: relative;
}

// 车辆信息样式
.vehicle-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-label {
  font-size: 14px;
  color: #666666;
  min-width: 80px;
}

.info-value {
  font-size: 14px;
  color: #5CACEE;
  font-weight: 500;
}

.info-value.status-active {
  color: #28a745;
}

.info-value.status-inactive {
  color: #6c757d;
}

// 概览统计样式
.overview-stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px;
  background: #e3f2fd;
  border-radius: 8px;
  border: 1px solid rgba(92, 172, 238, 0.3);
}

.stat-value {
  font-size: 20px;
  font-weight: bold;
  color: #5CACEE;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 12px;
  color: #666666;
}

// 响应式设计
@media (max-width: 1200px) {
  .test-data-container {
    flex-direction: column;
  }
  
  .left-content,
  .right-content {
    flex: 1;
    width: 100%;
  }
}

// 自定义 Ant Design 组件样式
:deep(.ant-select-selector) {
  background: #ffffff !important;
  border-color: rgba(92, 172, 238, 0.5) !important;
  color: #333333 !important;
}

:deep(.ant-select-dropdown) {
  background: #ffffff !important;
  border-color: rgba(92, 172, 238, 0.5) !important;
  
  .ant-select-item {
    color: #333333 !important;
    
    &.ant-select-item-option-active,
    &.ant-select-item-option-selected {
      background: rgba(92, 172, 238, 0.2) !important;
    }
  }
}

:deep(.ant-radio-group) {
  .ant-radio-button-wrapper {
    background: #ffffff !important;
    border-color: rgba(92, 172, 238, 0.5) !important;
    color: #333333 !important;
    
    &:hover {
      border-color: #5CACEE !important;
      color: #5CACEE !important;
    }
    
    &.ant-radio-button-wrapper-checked {
      background: #5CACEE !important;
      border-color: #5CACEE !important;
      color: #fff !important;
    }
  }
}

:deep(.ant-picker) {
  background: #ffffff !important;
  border-color: rgba(92, 172, 238, 0.5) !important;
  color: #333333 !important;
}

:deep(.ant-picker-dropdown) {
  background: #ffffff !important;
  border-color: rgba(92, 172, 238, 0.5) !important;
  
  .ant-picker-header {
    color: #333333 !important;
  }
  
  .ant-picker-cell {
    color: #333333 !important;
    
    &.ant-picker-cell-in-view.ant-picker-cell-selected .ant-picker-cell-inner {
      background: #5CACEE !important;
    }
  }
}
</style>